module.exports = __webpack_public_path__ + "img/9788996762287.80b890a0.jpg";